/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { FileBlock } from "src/classes/block/block-types";
import { FileBlockWrapper, FileName, IconWrapper } from "src/components/Block/BlockTypes/FileBlock/styles";
import { FileIcon } from "src/components/UI/Icons";

interface Props {
  block: FileBlock;
}

export const StandardFilePreview = ({ block }: Props) => {
  return (
    <FileBlockWrapper>
      <IconWrapper>
        <FileIcon />
      </IconWrapper>
      <FileName>
        {block.fileDisplayName} {block.readableFileSize}
      </FileName>
    </FileBlockWrapper>
  );
};
